import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import { Translate } from '@pegasus/translation';
import { Close } from '@browsing/icons';

import Spinner from '../spinner/Spinner';
import styles from './styles.scss';

const cn = classNames.bind(styles);

export class InfoBox extends PureComponent {
    static defaultProps = {
        iconComponent: null,
        onCloseClick: null,
        noCloseIcon: false,
        sticky: false,
        inline: false,
        pending: false,
    };

    contentRef = React.createRef();

    render() {
        const {
            title,
            iconComponent,
            children,
            onCloseClick,
            noCloseIcon,
            sticky,
            inline,
            pending,
        } = this.props;

        return (
            <div className={cn('wrapper', { sticky, inline })}>
                {!noCloseIcon && (
                    <div className={cn('close')} onClick={onCloseClick}>
                        <Close className={cn('close-icon')} />
                    </div>
                )}
                {!pending ? (
                    <div className={cn('wrapper-inner')} ref={this.contentRef}>
                        {iconComponent && (
                            <div className={cn('icon-section', { inline })}>{iconComponent}</div>
                        )}
                        <div className={cn('content-section', { sticky, inline })}>
                            <span className={cn('title')}>
                                <Translate message={title} html />
                            </span>
                            <div className={cn('content')}>{children}</div>
                        </div>
                    </div>
                ) : (
                    <div className={cn('loader-wrapper')} style={this.getLoaderHeight()}>
                        <div className={cn('loader')}>
                            <Spinner />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    getLoaderHeight = () => ({
        height: get(this, 'contentRef.current')
            ? `${this.contentRef.current.clientHeight}px`
            : 'auto',
    });
}

InfoBox.propTypes = {
    noCloseIcon: PropTypes.bool,
    title: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
        .isRequired,
    iconComponent: PropTypes.element,
    onCloseClick: PropTypes.func,
    sticky: PropTypes.bool,
    pending: PropTypes.bool,
};

export default InfoBox;
